export default {"src":"/_next/static/media/testimonials.9d10b2fc.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};